export const STAGE_OPTIONS = [
  {
    value: "lead_received",
    label: "Lead received",
    progress: 0,
  },
  {
    value: "requirements_received",
    label: "Requirements received",
    progress: 10,
  },
  {
    value: "proposal_shared",
    label: "Proposal/quotation Shared",
    progress: 30,
  },
  {
    value: "meeting",
    label: "Venue visit or meeting",
    progress: 40,
  },
  {
    value: "negotiation",
    label: "Negotiations running",
    progress: 55,
  },
  {
    value: "booking_process",
    label: "Booking under process",
    progress: 70,
  },
  {
    value: "verbal_confirmation",
    label: "Confirmation (Verbal)",
    progress: 80,
  },
  {
    value: "converted",
    label: "Converted (Payment received)",
    progress: 100,
  },
  {
    value: "not_converted",
    label: "Not converted (Dead)",
    progress: 0,
  },
];